import PublicationLink from './PublicationLink.component';

export default PublicationLink;